import { QuickScanCardComponent } from './components/quick-scan-card/quick-scan-card.component';
import { SearchesComponent } from './components/searches/searches.component';
import { SearchesDj2Component } from './components/searches/searches-dj2/searches-dj2.component';
import { SearchesDjComponent } from './components/searches/searches-dj/searches-dj.component';
import { SearchesInternetComponent } from './components/searches/searches-internet/searches-internet.component';
import { SearchesTrComponent } from './components/searches/searches-tr/searches-tr.component';
import { SearchesOwnNameComponent } from './components/searches/searches-own-name/searches-own-name.component';
import { SearchesArtemiscanComponent } from './components/searches/searches-artemiscan/searches-artemiscan.component';
import { EnginesOptionComponent } from './components/engines-option/engines-option.component';
export var MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY'
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
var SEARCHES_COMPONENTS = [
    SearchesComponent,
    SearchesDj2Component,
    SearchesDjComponent,
    SearchesInternetComponent,
    SearchesTrComponent,
    SearchesOwnNameComponent,
    SearchesArtemiscanComponent,
];
var QUICKSCAN_COMPONENTS = [
    EnginesOptionComponent,
    QuickScanCardComponent,
];
var ɵ0 = { duration: 20000 };
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
export { SharedModule };
export { ɵ0 };
